import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeApprovalRequired, makeProgress, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-approval-flow';
const CONV_ID = 'conv-9';
const MD_INTRO_BLOCK_ID = 'blk-approval-md-intro';
const CONFIRM_BLOCK_ID = 'blk-approval-confirm';
const MD_RESULT_BLOCK_ID = 'blk-approval-md-result';
const UNDO_BLOCK_ID = 'blk-approval-undo';
// eslint-disable-next-line prettier/prettier
const introText = 'I can update those 50 inspections to "Completed" status. This affects all inspections in Building A.';
const confirmationBlock = {
    type: 'confirmation',
    block_id: CONFIRM_BLOCK_ID,
    block_index: 1,
    approval_id: 'approval-bulk-update-001',
    thread_id: 'thread-bulk-update-001',
    severity: 'warning',
    title: 'Bulk Status Update',
    summary: 'Update 50 inspections to "Completed"',
    details: [
        '50 inspections in Building A will be marked as Completed',
        'This includes 12 inspections currently in "Scheduled" status',
        'Completion dates will be set to today'
    ],
    reversible: true,
    undo_window_minutes: 30,
    confirm_label: 'Yes, update all 50',
    cancel_label: 'Cancel',
    confirm_variant: 'primary'
};
const resultText = 'Done! I updated 50 inspections in Building A to "Completed" status successfully.';
const undoBlock = {
    type: 'undo',
    block_id: UNDO_BLOCK_ID,
    block_index: 3,
    action_id: 'action-bulk-update-001',
    summary: 'Undo bulk status update (50 inspections)',
    undo_available: true,
    expires_at: new Date(Date.now() + 30 * 60 * 1000).toISOString(),
    undo_window_minutes: 30
};
// The SSE sequence simulates the full Human-in-the-Loop flow.
// In a real scenario the stream would pause at approval_required and resume
// after POST /api/chat/{thread_id}/resume. Here we simulate the "approved"
// path with a longer delay representing the user's decision time.
const sseSequence = [
    // Phase 1: Initial response with markdown explanation
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_INTRO_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_INTRO_BLOCK_ID, introText, 20, 60),
    makeBlockEnd(MD_INTRO_BLOCK_ID),
    // Phase 2: approval_required — frontend renders ConfirmationBlock
    makeApprovalRequired(confirmationBlock, 600),
    // Phase 3: Simulated pause (3s) while "user decides", then progress
    makeProgress('executing', 'Updating inspection statuses...', mockOfficeAgent, 3000),
    // Phase 4: Result markdown streams in
    makeBlockStart(MD_RESULT_BLOCK_ID, 2, 'markdown'),
    ...splitTextIntoDeltas(MD_RESULT_BLOCK_ID, resultText, 20, 60),
    makeBlockEnd(MD_RESULT_BLOCK_ID),
    // Phase 5: Undo block delivered as block_complete
    makeBlockComplete(undoBlock, 400),
    // Phase 6: Stream ends
    makeStreamEnd(RESPONSE_ID, 4, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Approval Flow (Human-in-the-Loop)',
    description: 'Exercises the full approval_required → progress → result → undo flow. ' +
        'Simulates a bulk update that requires user confirmation before executing.',
    conversations: mockConversations,
    userMessage: 'Mark all 50 inspections in Building A as completed',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
